/* eslint-disable no-unused-expressions */
/**
 * Header.jsx — Matches HTML prototype nav layout exactly.
 *
 * Layout:  [Logo]                    [For Members | For Employers/Partners | Meet Myra | Log In | [See Myra in Action]]
 *           left                      all on the right, single nav-links group
 *
 * CSS classes used: site-header, header-inner, logo-text, nav-links,
 *                   nav-link, header-login, header-try-btn
 * No custom classes. No inline style overrides.
 */

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import checkBrowserSupport from "../self-assesment2/browserDetect.js";
import VoiceService from "../voice-agent/VH-Myra-FrontEnd.js";

export const Header = ({ setShowMemberBlockScreen = () => {}, onTryMyraClick }) => {
  const history = useHistory();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  /* ── Member login — original logic, untouched ── */
  const handleMeberLoginClick = () => {
    const check = checkBrowserSupport("member");
    if (!check.isSupported) {
      setShowMemberBlockScreen(true);
      return;
    }

    if (window.isStartedLandingFlow) {
      if (window.mayraCode) {
        window.mayraCode.setIsVisible(false);
        window.mayraCode.forceStop();
        VoiceService.destroyMyraCompletely(false);
        window.mayraCode = null;
        window.startFlow = null;
        window.currentCommandsAudio = {};
      }
      sessionStorage.removeItem("voiceService_wasListening");
      sessionStorage.removeItem("voiceService_currentFlow");
    }

    if (window.preloadAllAudios) window.preloadAllAudios();
    if (window.videoUnlockPlay) window.videoUnlockPlay();

    window.isThisFromHomeScreen = false;

    setTimeout(() => {
      if (!window.isFlutterLoaded) {
        const loader = document.getElementById("flutter-loader");
        if (loader) {
          loader.style.display = "flex";
          const loaderText = loader.querySelector("#loader-text");
          if (loaderText) loaderText.textContent = "Loading application...";
        }
      }

      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";

      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";

      localStorage.removeItem("loadSelf");
      localStorage.removeItem("startedSelf");

      window.doNextLocation = history;
      document.querySelector("html").classList = [];
      window.history.pushState({ loginGuard: true }, "");
      if (window._loginBackGuardHandler) {
        window.removeEventListener("popstate", window._loginBackGuardHandler);
      }
      const handlePopState = () => {
        if (typeof window.showLoginBackGuard === "function") {
          window.showLoginBackGuard();
        }
      };
      window._loginBackGuardHandler = handlePopState;
      window.addEventListener("popstate", handlePopState);

      setTimeout(() => {
        if (window.setHideElementsElm) window.setHideElementsElm(true);
      }, 2000);
    }, 100);
  };

  const navigateToSection = (sectionId) => {
    if (location.pathname !== "/") {
      history.push("/");

      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({
          behavior: "smooth",
        });
      }, 100);
    } else {
      document.getElementById(sectionId)?.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <header className="site-header">
      <div className="header-inner">
        {/* Logo — left */}
        <Link to="/" className="logo-text">
          <img src="/images/healthlogo1.svg" alt="Virdio Health" width="155" height="35" />
        </Link>

        {/*
          All nav items together on the right — single nav-links group.
          Mirrors the prototype exactly:
          For Members | For Employers/Partners | Meet Myra | Log In | [See Myra in Action]
        */}
        <nav className="nav-links">
          <button onClick={() => navigateToSection("members")} className="nav-link">
            For Members
          </button>
          <button onClick={() => navigateToSection("employers")} className="nav-link">
            For Employers/Partners
          </button>
          <button onClick={() => navigateToSection("myra")} className="nav-link">
            Meet Myra
          </button>
          <button type="button" className="header-login" onClick={handleMeberLoginClick}>
            Log In
          </button>
          <button type="button" className="header-try-btn" onClick={() => window.location.replace("https://myptmyra.com/intake/lower-back")}>
            See Myra in Action
          </button>
        </nav>
        <button type="button" className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Menu">
          <span />
          <span />
          <span />
        </button>

        <div className={`mobile-nav ${mobileMenuOpen ? "open" : ""}`}>
          <button
            onClick={() => {
              navigateToSection("members");
              setMobileMenuOpen(false);
            }}
            className="mobile-nav-link"
          >
            For Members
          </button>

          <button
            onClick={() => {
              navigateToSection("employers");
              setMobileMenuOpen(false);
            }}
            className="mobile-nav-link"
          >
            For Employers/Partners
          </button>

          <button
            onClick={() => {
              navigateToSection("myra");
              setMobileMenuOpen(false);
            }}
            className="mobile-nav-link"
          >
            Meet Myra
          </button>

          <button
            type="button"
            className="mobile-nav-link"
            onClick={() => {
              handleMeberLoginClick();
              setMobileMenuOpen(false);
            }}
          >
            Log In
          </button>

          <button
            type="button"
            className="header-try-btn mobile-cta"
            onClick={() => {
              setMobileMenuOpen(false);
              window.location.replace("https://myptmyra.com/intake/lower-back");
            }}
          >
            See Myra in Action
          </button>
        </div>
      </div>
    </header>
  );
};
